import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../_guards/auth.guard';
import { PerformActionPage } from '../../components/performaction/performaction.page';

const routes: Routes = [
  { path: ':requestId', component: PerformActionPage, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PerformactionRoutingModule { }
